import { render, staticRenderFns } from "./IQUserPrompt.vue?vue&type=template&id=75ddedfe&scoped=true"
import script from "./IQUserPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./IQUserPrompt.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQUserPrompt.vue?vue&type=style&index=0&id=75ddedfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ddedfe",
  null
  
)

export default component.exports